/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import * as consts from '../../const.js';

class DocumentStatusService {
  static documentStatusesToOptions(documentStatuses, currentStatus, handleStatusChange) {
    let options = [];

    if (documentStatuses) {
      for (let docStatus of documentStatuses) {
        const option = {
          value: docStatus,
          label: (
            <div>
              <p className="option-text">{consts[docStatus]}</p>
              <p className="option-details">{consts[docStatus + '_DETAILS']}</p>
            </div>
          )
        };
        options.push(option);
      }
    }
    return options;
  }
}

export default DocumentStatusService;
